// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"18356737","952":"d4028ad9"}[chunkId] + ".chunk.js";
};